import { translate } from 'react-polyglot';
import { Dropdown, DropdownCheckedItem } from 'decap-cms-ui-default';
import { ControlButton } from './ControlButton';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
function FilterControl({
  viewFilters,
  t,
  onFilterClick,
  filter
}) {
  const hasActiveFilter = filter?.valueSeq().toJS().some(f => f.active === true);
  return _jsx(Dropdown, {
    renderButton: () => {
      return _jsx(ControlButton, {
        active: hasActiveFilter,
        title: t('collection.collectionTop.filterBy')
      });
    },
    closeOnSelection: false,
    dropdownTopOverlap: "30px",
    dropdownPosition: "left",
    children: viewFilters.map(viewFilter => {
      return _jsx(DropdownCheckedItem, {
        label: viewFilter.label,
        id: viewFilter.id,
        checked: filter.getIn([viewFilter.id, 'active'], false),
        onClick: () => onFilterClick(viewFilter)
      }, viewFilter.id);
    })
  });
}
export default translate()(FilterControl);